import md5 from "md5";
import { loginWap } from "@/views/api/user";
import jwt from "jsonwebtoken";
import Cookies from "js-cookie";
import { decrypt, encrypt } from "./booked";
import i18n from "@/plugins/i18n";

// const TokenKey = "Admin-Token";
const InformationKey = "info";
const FlagKey = "flag";
const LanguageKey = "language";
const BackGroundKey = "BackGround";

const FE_LANG_SP = [
    'vi',
    'en',
    'kr',
    'jp',
]

const FE_FLAG = {
    'vi': 'vn',
    'en': 'us',
    'kr': 'kr',
    'jp': 'jp',
}


export const sourceBuyWap = "source-buy";

export const posterModalId = "poster-modal-id";
export const eventSendInfoUserGa = "event-send-info-user-ga";

export function setToken(token) {
  return localStorage.setItem(InformationKey, JSON.stringify(token));
}

export function getToken() {
  if (localStorage.getItem(InformationKey))
    return JSON.parse(localStorage.getItem(InformationKey));
  return {
    vga: "",
    token: "",
    fullname: ""
  };
}
export function decodeToken() {
  let token = getToken().token;
  return jwt.decode(token);
}
export const getInfo = () => localStorage.getItem(InformationKey);

export const setInfo = () => localStorage.setItem(InformationKey);

export const getFlag = () => localStorage.getItem(FlagKey);

export const setFlag = flag => localStorage.setItem(FlagKey, flag);

export const removeFlag = () => localStorage.removeItem(FlagKey);

export const getLanguage = () => localStorage.getItem(LanguageKey);

export const setLanguage = lang => localStorage.setItem(LanguageKey, lang);

export const removeLanguage = () => localStorage.removeItem(LanguageKey);

export const setLocaleByLang = lang => {
  if(!lang) return;
  lang = String(lang).toLowerCase() || getLanguage() || 'vi';
  if(!(FE_LANG_SP.includes(lang))) lang = getLanguage() || 'vi';
  setLanguage(lang);
  setFlag(FE_FLAG[lang]);
  
  i18n.locale = lang;
}

export async function setupLoginWap(self) {
  let currentUrl = window.location.host;
  if (currentUrl == "localhost:8080") {
    if (!checkTokenExists()) {
      if (checkSignData(self)) {
        //call api login get token
        let dataLogin = {
          phone: self.$router.history.current.query.phone,
          signdata: renderSignData(self.$router.history.current.query.phone)
        };
        await loginWap(dataLogin).then(res => {
          if (res.error_code === 200) {
            localStorage.setItem(InformationKey, JSON.stringify(res.data.data));
            window.location.href = window.location.href;
          }
        });
      }
    }
  }
}

export function renderSignData(phone) {
  let secretKey = process.env.VUE_APP_SECRET_KEY;
  return md5(secretKey + phone);
}

export function checkTokenExists() {
  let token = getToken().token;
  return !!token.length;
}

export function checkSignData(self) {
  let params = self.$router.history.current.query;
  if ("signdata" in params && "phone" in params) {
    let signdata = params.signdata;
    let phone = params.phone;
    if (signdata.length && phone.length) {
      let signDataRender = renderSignData(phone);
      return signDataRender === signdata;
    }
  } else {
    return false;
  }
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

export function setBackGround(info) {
  return localStorage.setItem(BackGroundKey, JSON.stringify(info));
}

export function getBackGround() {
  if (getToken().bank_id == 7)
    return {
      c_input: "#000",
      c_background1: "#ffff",
      c_background2: "#006B68",
      c_background3: "#B18535",
      c_background4: "#006B68",
      c_white_background:
        "linear-gradient(180deg, rgba(166, 205, 204, 0.9) 0%, #F0F5F5 20%)",
      c_cyan_background: "#E6F0F0",
      c_inherit_background:
        "linear-gradient(180deg, rgba(166, 205, 204, 0.9) 0%, #F0F5F5 20%)",
      c_white_text_important: "#ffffff",
      c_red_text: "#006B68",
      c_white_text: "#ffffff",
      c_text_main: "#006B68",
      c_inherit_text: "#006B68",
      c_button_main: "#006B68",
      c_border: "#006B68",
      c_border2: "var(--Foreground-Secondary-Default, #ffc62f)",
      c_border3: "var(--Border-Primary-Light, #e6f0f0)",
      c_button_text: "#fb7800",
      c_text_price: "#fb7800",
      colorMain: "#006B68",
      c_btn_hotline: "#006B68",
      c_box_header_tee: "#006B68",
      font: "Plus Jakarta Sans",
      c_placeholder: "#666666",
      c_box_header_tee2: "#006B68",
      fw_cv1: 500,
      fw_cv2: 700,
      fw_cv3: 500,
      fw_cv4: 700,
      fs_cv1: "12px",
      fs_cv2: "14px",
      fs_cv3: "11px",
      fs_cv4: "11px",
      //fs_input: "13.95px",
      fs_input: "10px",

      b_radius1: "24px",
      b_radius2: "20px",

      icon_search: require("@/assets/img/v3/icon/icon_ht_search.svg"),
      icon_address: require("@/assets/img/v3/icon/icon_ht_location.svg"),
      icon_address1: require("@/assets/img/v3/icon/icon_ht_location.svg"),
      icon_time: require("@/assets/img/v3/icon/icon_ht_calendar.svg"),
      icon_user: require("@/assets/img/v3/icon/icon_ht_user.svg"),
      icon_hio: require("@/assets/img/iconV2/shield-icon.svg"),
      icon_closed: require("@/assets/img/v3/icon/icon_closed.svg"),
      icon_closed_2: require("@/assets/img/v3/icon/icon_closed.svg"),

      icon_home: require("@/assets/img/v3/icon/icon_home.svg"),
      icon_checked: require("@/assets/img/v3/icon/checked.svg"),
      icon_circle: require("@/assets/img/v3/icon/icon_circle.svg"),
      icon_drop_right: require("@/assets/img/v3/icon/icon_drop_right.svg"),
      icon_drop_down: require("@/assets/img/v3/icon/icon_drop_down.svg"),
      icon_menu_home: require("@/assets/img/v3/icon/icon_menu_home.svg"),
      icon_menu_more: require("@/assets/img/v3/icon/icon_menu_more.svg"),
      icon_menu_order: require("@/assets/img/v3/icon/icon_menu_order.svg"),
      icon_menu_search: require("@/assets/img/v3/icon/icon_menu_search.svg"),
      icon_menu_user: require("@/assets/img/v3/icon/icon_menu_user.svg"),
      icon_order: require("@/assets/img/v3/icon/icon_order.svg"),
      icon_user_profile: require("@/assets/img/v3/icon/icon_ht_user.svg"),
      icon_arrow_input: require("@/assets/img/v3/icon/arrow_down.svg"),
      icon_location_2: require("@/assets/img/v3/icon/icon_location_2.svg"),
      icon_clock: require("@/assets/img/v3/icon/icon_clock.svg"),
      icon_calendar_2: require("@/assets/img/v3/icon/icon_calendar_2.svg"),
      icon_menu_price_table: require("@/assets/img/v3/icon/icon_table_price_bidv.svg"),
      icon_fly: require("@/assets/img/v3/icon/icon_fly_bidv.svg")
    };
  //Default
  return {
    c_input: "#17479e",
    c_background1: "#ffff",
    c_background2: "#021944",
    c_background3: "#17479e",
    c_background4: "#FF0000",
    c_cyan_background: "#f5f5f5",
    c_white_background: "#ffffff",
    c_inherit_background: "#f5f5f5",
    c_white_text_important: "#ffffff",
    c_red_text: "#FF2424",
    c_white_text: "#ffffff",
    c_text_main: "#17479e",
    c_inherit_text: "#406EE2",
    c_button_main: "#17479e",
    c_border: "#17479e",
    c_border2: "#406EE2",
    c_border3: "#17479E",
    c_button_text: "#fb7800",
    c_text_price: "#fb7800",
    colorMain: "#17479e",
    c_box_header_tee: "linear-gradient(270deg, #406ee2 0%, #1b4685 100%)",
    c_box_header_tee2: "linear-gradient(90deg, #025890 0%, #0971B5 100%)",
    c_btn_hotline: "#ff0000",
    font: "SF Pro Display, sans-serif",
    c_placeholder: "#17479E",
    fw_cv1: 600,
    fw_cv2: 500,
    fw_cv3: 700,
    fw_cv4: 600,
    fs_cv1: "14px",
    fs_cv2: "16px",
    fs_cv3: "14px",
    fs_cv4: "12px",
    fs_input: "10px",
    b_radius1: "8px",
    b_radius2: "8px",

    icon_search: require("@/assets/img/svg/searchIcon.svg"),
    icon_address: require("@/assets/img/v3/icon/icon_address_wghn.svg"),
    icon_address1: require("@/assets/img/v3/icon/icon_location_1.svg"),
    icon_time: require("@/assets/img/v3/icon/icon_time_wghn.svg"),
    icon_user: require("@/assets/img/v3/icon/icon_user_wghn.svg"),
    icon_hio: require("@/assets/img/iconV2/shield-icon.svg"),
    icon_closed: require("@/assets/img/svg/close-icon.svg"),
    icon_closed_2: require("@/assets/img/v3/icon/icon_close_red_wghn.svg"),
    icon_home: require("@/assets/img/v3/icon/icon_ht_home_main.svg"),
    icon_checked: require("@/assets/img/svg/checkbox_active.svg"),
    icon_circle: require("@/assets/img/svg/checkbox_inactive.svg"),
    icon_drop_right: require("@/assets/img/iconV2/arrow-right.svg"),
    icon_drop_down: require("@/assets/img/svg/arrow-down.svg"),
    icon_menu_home: require("@/assets/img/v3/icon/icon_menu_home_main.svg"),
    icon_menu_more: require("@/assets/img/v3/icon/icon_menu_more_main.svg"),
    icon_menu_order: require("@/assets/img/v3/icon/icon_menu_order_main.svg"),
    icon_menu_search: require("@/assets/img/v3/icon/icon_menu_search_main.svg"),
    icon_menu_user: require("@/assets/img/v3/icon/icon_menu_user_main.svg"),
    icon_order: require("@/assets/img/iconV2/order_icon.svg"),
    icon_user_profile: require("@/assets/img/iconV2/user.svg"),
    icon_arrow_input: require("@/assets/img/v3/icon/icon_drop_right_wghn.svg"),
    icon_location_2: require("@/assets/img/v3/icon/icon_location_2.svg"),
    icon_clock: require("@/assets/img/v3/icon/icon_clock.svg"),
    icon_calendar_2: require("@/assets/img/v3/icon/icon_calendar_2.svg"),
    icon_menu_price_table: require("@/assets/img/v3/icon/icon_table_price_wghn.svg"),
    icon_fly: require("@/assets/img/v3/icon/icon_fly_wghn.svg")
  };
}

export const removeBackGround = () => localStorage.removeItem(BackGroundKey);

export const setCookie = (name, value, options = {}) => {
  const dataEnc = encrypt(value);
  Cookies.set(name, dataEnc, options);
};

export const getCookie = name => {
  const value = Cookies.get(name);
  return decrypt(value);
};

export const removeCookie = name => {
  Cookies.remove(name);
};
